export class User {
  public id: number;
  public name: string;
  public password: string;
  public email: string;
  public token: string;
  public role: string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/_model/user.ts